export const uppercase = (value) => {
	if (!value) return ''
	value = value.toString()
	return typeof value === 'string' ? value.toUpperCase() : value;
};
